<ng-container>
  <h5>Auto Attendant Timeout</h5>
  @if (extensionAutoAttendant?.timeoutSeconds != null) {
    <div class="extension-detail-item"
      >{{ extensionAutoAttendant?.timeoutSeconds }}
      {{ extensionAutoAttendant?.timeoutSeconds > 1 ? 'seconds' : 'second' }}
    </div>
  }
</ng-container>
@if (extensionAutoAttendant?.timeoutExtension == null && extensionAutoAttendant?.timeoutSeconds != null) {
  <h5>Timeout Extension</h5>
  <div class="extension-detail-item">{{
    extensionAutoAttendant?.timeoutNullAction == 'Directory'
    ? 'Name Directory'
    : extensionAutoAttendant.timeoutNullAction
  }}</div>
}
<ndt-extension-detail-link
  [extension]="extensionAutoAttendant?.timeoutExtension"
  [header]="'Timeout Extension'"
></ndt-extension-detail-link>
